import AddButton from "components/Button/AddButton";
import React, { useEffect, useState } from "react";
import TrashIcon from "assets/icon/TrashIcon";
import { useNavigate } from "react-router-dom";
import { DropdownStatusList, EmptyString, FormTypeAdd, PageSize } from "utils/Constant";
import EditIcon from "assets/icon/EditIcon";
import SearchButton from "components/Button/SearchButton";
import Dropdown from "components/Input/Dropdown";
import { GetStatus } from "utils/helpers";
import RevisionIcon from "assets/icon/RevisionIcon";
import { LocationService } from "services/LocationService/LocationService";
import { useModal } from "context/ModalContext";
import Pagination from "components/Input/PaginationButton";

export default function Location(){
    // Navigate
    let navigate = useNavigate()
    const { fetchLocationList, fetchDeleteLocation } = LocationService()
    const { showFail, showLoading, hideLoading, showSuccess, confirm } = useModal()

    // Filter
    const [locationName, setLocationName] = useState(EmptyString)
    const [status, setStatus] = useState(DropdownStatusList[1].value)

    // Grid 
    const [locationList, setLocationList] = useState([])
    const [pageIndex, setPageIndex] = useState(0)
    const [totalPages, setTotalPages] = useState(0)

    const handlePageChange = async (newIndex) => {
        try {
            showLoading()

            const res = await fetchLocationList(
                locationName, 
                status, 
                PageSize, 
                parseInt(newIndex)
            )

            if (!res) return

            const totalData = res?.data?.totalData ?? 0;
            const total = Math.max(1, Math.ceil(totalData / PageSize));

            setLocationList(res)
            setTotalPages(total);
            setPageIndex(newIndex);
        } finally {
            hideLoading();
        }
    }

    // Button Event
    const addBtnClick = () => { 
        navigate("/setting/location/form?locationId=&formType=" + FormTypeAdd) 
    }
    const searchBtnClick = () => { 
        handlePageChange(0)
    }
    const editBtnClick = (id) => {
        navigate("/setting/location/form?locationId=" + id + "&formType=Edit")
    }
    const deleteBtnClick = async (id, status) => {
        const isConfirmed = await confirm()

        if (isConfirmed) {
            showLoading()

            try {
                const res = await fetchDeleteLocation(id, status)
                if (!res) return

                showSuccess({
                    onSuccess: () => {
                        handlePageChange(pageIndex)
                    }
                })
            } finally {
                hideLoading()
            }
        }
    }

    function fEnterKeyDown(e){
		if(e.key === 'Enter'){
			handlePageChange(0)
		}
	}

    useEffect(() => {
        const timeout = setTimeout(() => {
            handlePageChange(0)
        }, 500); // wait 500ms

        return () => clearTimeout(timeout)
    }, [locationName])

    // On Load
    useEffect(() => {
        handlePageChange(0)
    },[status])

    return(
        <div className="flex flex-col gap-2">
            <div >
                <span className="font-semibold text-2xl">Location</span>
            </div>
            <hr />

            <div className="flex flex-col sm:flex-row gap-5 justify-between mt-5">
                <div className="flex flex-col sm:flex-row gap-2 sm:gap-4 w-full">
                    <div className="flex flex-col gap-2 w-full sm:w-80">
                        <span>Location</span>
                        <input className="input" value={locationName} onChange={(e) => setLocationName(e.target.value)} onKeyDown={(e) => {fEnterKeyDown(e)}} />
                    </div>
                    <div className="flex flex-col gap-2 w-full sm:w-32">
                        <span>Status</span>
                        <Dropdown value={status} options={DropdownStatusList} onChange={(e) => setStatus(e.value)} placeholder={"All"} />
                    </div>
                </div>
                <div>
                    <div className="flex justify-end items-end h-full">
                        <SearchButton onClick={searchBtnClick} />
                    </div>
                </div>
            </div>

            <div className="flex w-full justify-end">
                <AddButton onClick={addBtnClick} />
            </div>
           
            <div className="mt-5">
                <table className="w-full border bg-white">
                    <thead>
                        <tr className="h-12">
                            <th className="font-semibold w-16">No</th>
                            <th className="font-semibold text-left px-2 hidden sm:table-cell">Location Name</th>
                            <th className="font-semibold text-left px-2">Address</th>
                            <th className="font-semibold text-left px-2">City</th>
                            <th className="font-semibold text-left px-2 hidden sm:table-cell">Status</th>
                            <th className="font-semibold sm:w-24">Action</th>
                        </tr>
                    </thead>
                    <tbody className="border">
                        {locationList?.data?.listData?.map((data, i) => {
                            return(
                                <tr className="my-2 row h-10 border-y hover:bg-slate-100" key={ i }>
                                    <td className="text-center">{ data.rowNumber }</td>
                                    <td className="px-2 hidden sm:table-cell">
                                        <span>{ data.locationName.toUpperCase() }</span>
                                    </td>
                                    <td className="px-2">
                                        <span>{ data.address.toUpperCase() }</span>
                                    </td>
                                    <td className="px-2">
                                        <span>{ data.city.toUpperCase() }</span>
                                    </td>
                                    <td className="px-2 hidden sm:table-cell">
                                        <span>{ GetStatus(data.status) }</span>
                                    </td>
                                    <td className="flex flex-col sm:flex-row justify-center py-2 gap-2 px-2">
                                        <button className="button flex gap-2" onClick={ () => editBtnClick(data.locationId) }>
                                            <EditIcon className="w-4 fill-white" />
                                        </button>
                                        <button className={`button flex gap-2 ${ data.status === "2" ? "hidden" : "block" }`} onClick={() => deleteBtnClick(data.locationId, data.status)}>
                                            <TrashIcon className="w-4 fill-white" />
                                        </button>
                                        <button className={`button flex gap-2 ${ data.status === "1" ? 'hidden' : 'block' }`} onClick={() => deleteBtnClick(data.locationId, data.status)}>
                                            <RevisionIcon className="w-4 fill-white" />
                                        </button>
                                    </td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </div>

            <Pagination pageIndex={pageIndex} totalPages={totalPages} onPageChange={handlePageChange} />
        </div>
    )
}